import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { makeGetRequest } from "../../services/httpHelper";
import ErrorHandler from "../../services/ErrorHandler";
import { useCurrency } from "../../context/currencyContext";
import { toTitleCase } from "../../utils/myFunctions";
import formatCurrency from "../../utils/formatCurrency";
import { Container,Row, Col, Card,Button } from 'react-bootstrap';
import { FaCheckCircle } from "react-icons/fa";


const features ={
  solo:[
    "Offline functionality with no internet required",
     "Member registration and contributions",
     "Loan management and repayment tracking",
     "Meeting records and reporting",
     "Print-ready financial statements"
  ],
  soloAddons:[
  "M-PESA Integration: Enable payment automation with STK push and reconciliation (internet required).",
"Bulk SMS Notifications: Send meeting reminders, payment alerts, and updates to members.",
"Cloud Backups: Secure your data in the cloud for peace of mind (optional).",
"LAN Syncing: For multi-device access on same local network (Standard and Pro tiers)"
  ],
  team:[
    "Offline usage across LAN (no internet needed)",
 "Admin panel for user roles and access control",
 "Comprehensive reporting and auditing",
 "Built-in backups and data export options",
 "Expandable based on number of members"

  ],
  teamAddons:[
    "M-PESA Integration: One-time setup for Paybill or Till support",
    "Bulk SMS (Safaricom/Airtel): Includes Sender ID registration and credit purchase",
    "Custom Hardware Bundles: Add computers, printers, routers for full setup",
  "IT Support Plans: Available for organizations that need remote or onsite assistance"
  ],
  cloud:[
    "Secure cloud hosting with automatic updates and backups",
    "M-PESA integration for automated payments and statements",
    "SMS alerts with registered Sender ID (Safaricom & Airtel)",
    "Seamless collaboration with access from any connected location",
    "Compatible with Windows desktops (no browser login required)"

  ],
  cloudAddons:[
    "Cloud Support Plan",
    "Custom Integrations",
    "Data Migration from Excel or Other Systems",
    "Annual subscription model (includes updates & cloud services)",
    "Custom domain & branding options for organizations"

  ]
}




export default function PricingSection() {
  const [openEdition, setOpenEdition] = useState(null);
  const { currency, setCurrency, convert } = useCurrency();
     const [isLoading,setIsLoading] = useState(false);
     const [serverError,setServerError] = useState(null);
    const [plans, setPlans] = useState([]);

  const toggleEdition = (edition) => {
    setOpenEdition(openEdition === edition ? null : edition);
  };
  const navigate = useNavigate()

  const getPlans = async()=>{
          setIsLoading(true);
          const res = await makeGetRequest(`product/plans`);
          if (res && res.errorType) {
              setIsLoading(false);
              const errorMessage = ErrorHandler(res)
              setServerError(errorMessage)
      
          } else {
            const results = await res.data;
            
              setPlans(results)        
              setIsLoading(false);
              setServerError(null)
              
      
          }
         
      }
  
    useEffect(() => {
     getPlans();
    }, []);

  return (
       <Wrapper id="pricing">
      <div className="container">
        <h2 className="font40 extraBold textCenter">Transparent Pricing for Every Group Size</h2>
        <p className="font16 textCenter" style={{ marginBottom: "40px" }}>
          No hidden fees. Choose the edition and license that fits your group's needs.
        </p>

        {Object.keys(plans).map((edition) => (
          <EditionCard key={edition}>
            <EditionHeader onClick={() => toggleEdition(edition)}>
              <h3>{toTitleCase(edition)} Edition</h3>
              <span>{openEdition === edition ? "−" : "+"}</span>
            </EditionHeader>
            {openEdition === edition && (
              <TableWrapper>
                <table>
                  <thead>
                    <tr>
                      <th>License</th>
                      <th>Price</th>
                    <th>Terms</th>

                    </tr>
                  </thead>
                  <tbody>
                    {plans[edition].map((row, idx) => (
                      <tr key={idx}>
                        <td>{toTitleCase(row.name)}</td>
                        
                        <td>{formatCurrency((row.price_kes/100).toFixed(2))}</td>
                        <td>{`${edition=='solo'||edition=='team'?' (One-time Payment)':'/Yearly'}`}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Container>
                {/* Key Features */}
                <h4>Key Features</h4>
                <Row>
                  {features[edition]?.map((feature, idx) => (
                    <Col md={2} sm={4} xs={12} key={idx} className="mb-3 d-flex align-items-start">
                      <FaCheckCircle className="text-success me-2 mt-1" />
                      <span>{feature}</span>
                    </Col>
                  ))}
                </Row>

                {/* Addons */}
                {features[`${edition}Addons`] && features[`${edition}Addons`].length > 0 && (
                  <>
                    <h4 className="mt-4">Addons</h4>
                    <Row>
                      {features[`${edition}Addons`].map((addon, idx) => (
                        <Col md={3} sm={6} xs={12} key={idx} className="mb-3 d-flex align-items-start">
                          <FaCheckCircle className="text-success me-2 mt-1" />
                          <span>{addon}</span>
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
              </Container>
                
                 <div style={{ textAlign: "center", padding: "20px" }}>
                <button
                  style={{
                    backgroundColor: "purple",
                    color: "#fff",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(`/pricing/${edition.toLowerCase()}`)}
                >
                  Choose Your Plan
                </button>
              </div>
              </TableWrapper>
            )}
          </EditionCard>
        ))}
      </div>
    </Wrapper>

   
  );
}

const Wrapper = styled.section`
  padding: 80px 0;
  background: #fff;
`;

const EditionCard = styled.div`
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
`;

const EditionHeader = styled.div`
  background: #f5f5f5;
  padding: 15px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
    font-size: 20px;
    color: purple;
  }
  span {
    font-size: 24px;
    font-weight: bold;
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  th, td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid #eee;
  }
  th {
    background: #fafafa;
    font-weight: 600;
  }
`;
